import { Box, Grid, styled } from "@mui/material";

export const TableProBlock = styled(Box)(({}) => ({
  position: "relative",
  "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
    boxShadow: "1px 0px rgb(224, 224, 224), inset 1px 0px rgb(224, 224, 224)",
  },

  "& .MuiDataGrid-columnHeaderTitleContainerContent,& .MuiDataGrid-columnHeaderTitleContainerContent p, & .MuiDataGrid-cellContent":
    {
      lineHeight: "normal",
    },

  "& .MuiDataGrid-footerContainer": {
    paddingTop: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  "& .MuiDataGrid-columnSeparator--sideRight": {
    visibility: "visible!important",
    "& svg": {
      overflow: "initial",
      "& path": {
        opacity: 0,
        backgroundColor: "red",
      },
    },
  },
}));

export const PaginationBlock = styled(Grid)({
  display: "flex",
  alignItems: "center",
  // border: '1px solid #E6E6E6',
  // justifyContent: 'space-between',
  width: "100%",
  padding: "0.5rem",
  // marginTop: '0.5rem',
});

export const PaginationStyled = styled("div")(({ theme }) => ({
  "& .Mui-selected": {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontWeight: "700",
    "&:hover": {
      backgroundColor: `${theme.palette.primary.dark} !important`,
    },
  },
}));
